export default __webpack_public_path__ + "static/media/footer_figma.0f478aec.svg";